import React from "react";
import { ProductsContext } from "../../context/ProductsContext";
import ST1_odds from "../../consts/ST1_odds";
import ST1_odds_old from "../../consts/ST1_odds_old";
import products from "../../consts/products";
import bg_video from "../../dist/img/Flowdia_Q_BG_movie.mov";
import { useLocation, Link } from "react-router-dom";
const Question4 = ({ deleteStep , setAnswer4, addStep, answer1_5, answer2, answer3 }) => {
  const { p1, p1_old } = React.useContext(ProductsContext);
  const [product1, setProduct1] = p1;
  const [product1_old, setProduct1_old] = p1_old;

  const answerHandler = (option) => {
    setAnswer4(option);
    product1Handler(option);
    product1Handler_old(option);
    addStep();
  };

  const product1Handler = (answer4) => {
    const result1 = ST1_odds.find(
      (i) =>
        i.answer2 === answer2 && i.answer3 === answer3 && i.answer4 === answer4
    );
    const product_1 = products.find((p) => p.id === result1.product);

    setProduct1(product_1);
  };
  const product1Handler_old = (answer4) => {
    const result1_old = ST1_odds_old.find(
      (i) =>
        i.answer2 === answer2 && i.answer3 === answer3 && i.answer4 === answer4
    );
    const product_1_old = products.find((p) => p.id === result1_old.product);

    setProduct1_old(product_1_old);
  };

  return (
    <section className="c-question">
      <video poster="" autoPlay loop playsInline muted>
        <source src={bg_video} type="video/mp4"></source>
      </video>
  
      <section className="c-question__progress">
        <dl>
          <dt>QUESTION</dt>
          <dd>
            5 / <span>14</span>
          </dd>
        </dl>
      </section>

      <section className="c-question__content p-question__content p-question__content--3 c-box2">
        <h1 className="c-question__title p-question__title">
          なりたい質感のイメージは？
        </h1>

        {(answer2 === "option1" &&
          (answer3 === "option1" || answer3 === "option2")) ||
        (answer2 === "option2" && answer3 === "option1") ? (
          <section
            onClick={() => answerHandler("option1")}
            className="c-question__option p-question__option p-question__option--3"
          >
            <p>
              ふんわり
              <br />
              弾力
            </p>
          </section>
        ) : null}
        <section
          onClick={() => answerHandler("option2")}
          className="c-question__option p-question__option p-question__option--3"
        >
          <p>
            サラサラ
            <br />
            なめらか
          </p>
        </section>
        <section
          onClick={() => answerHandler("option3")}
          className="c-question__option p-question__option p-question__option--3"
        >
          <p>
            やわらか
            <br />
            なめらか
          </p>
        </section>
        {(answer2 === "option1" &&
          (answer3 === "option1" || answer3 === "option2")) ||
        (answer2 === "option2" && answer3 === "option1") ? null : (
          <section
            onClick={() => answerHandler("option4")}
            className="c-question__option p-question__option p-question__option--3"
          >
            <p>
              うるおい
              <br />
              しっとり
            </p>
          </section>
        )}
        <Link style ={{  margin: "25px auto"}} onClick={() => deleteStep()}  className="c-question__btn2 p-output__btn--v2">
          BACK
        </Link>
      </section>
    </section>
  );
};

export default Question4;
